<template>
  <div>
    <div class="p-ml-3 p-mb-0" v-if="employee">
      <h2 class="p-mb-0">{{ employee.name  }}</h2>
      <p class="subHeader">Prosjekter</p>
    </div>
    <projects employee/>
  </div>
</template>

<script>
import projects from '@/components/projects/projects'

export default {
name: 'employeeDetails',
components: {
  projects,
},

created(){
  this.$store.dispatch('projects/inspect', {id: this.$route.params.id, type: 'user'})
  this.$store.dispatch('user/inspect', this.$route.params.id)
},

methods: {

},

computed: {
  projects(){
    return this.$store.getters["projects/inspect"]
  },

  employee(){
    return this.$store.getters["user/inspect"] 
  }
}

}
</script>